import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const imageApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/images/`,
      {params: params})
  },
  detail (imageId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/images/${imageId}/`,
      {params: params})
  }
}

export default imageApi
